export default __webpack_public_path__ + "static/media/p.60b604ed.png";